import apiClient from '@/services/axios'
import { transformIntoQuery } from '@/utils/pagination'

class AuctionService {
  constructor() {
    this.$api = apiClient
  }

  getAuctions(pagination, sort, filter) {
    const query = transformIntoQuery(pagination, sort, filter)
    return this.$api.get(`admin/auctions${query}`)
  }

  getAuctionById(id) {
    return this.$api.get(`admin/auctions/${id}`)
  }

  getBlockedCategories() {
    return this.$api.get('admin/auctions/categories')
  }

  getQuotes() {
    return this.$api.get('/admin/auctions/quotes')
  }

  createAuction(payload) {
    return this.$api.post('admin/auctions', payload)
  }

  deleteAuction(id) {
    return this.$api.get(`admin/auctions/forceClose/${id}`)
  }

  setWinner(payload) {
    return this.$api.post('/admin/auctions/setWinner', payload)
  }
}

export default new AuctionService()
